import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { School } from '../school';
import { Router } from '@angular/router';
import { SchoolListItem } from '../school-list-item';

@Component({
  selector: 'app-schools',
  templateUrl: './schools.component.html',
  styleUrls: ['./schools.component.css']
})
export class SchoolsComponent implements OnInit {

  schools: SchoolListItem[] = [];
  searchTerm: string = "";
  searchOption = "name";
  filteredSchools: SchoolListItem[] = [];
  displayOptions = [
    { label: "All", value: 1 },
    { label: "Active", value: 2 },
    { label: "Inactive", value: 3 }
  ];
  selectedOption = this.displayOptions[1].value;

  constructor(
    private httpService: HttpService,
    private router: Router
  ) { }

  ngOnInit() {
    this.httpService.getSchools().subscribe(res => {
      this.schools = res.reverse();
      this.updateFilter(this.selectedOption);
    });
  }

  editSchool(id: number) {
    this.router.navigateByUrl("/management/edit-school/" + id);
  }

  showInactiveSchools() {
    this.filteredSchools = this.schools.filter(school => {
      return school.isActive == false;
    });
  }

  showActiveSchools() {
    this.filteredSchools = this.schools.filter(school => {
      return school.isActive == true;
    });
  }

  showAllSchools() {
    this.filteredSchools = this.schools;
  }

  updateFilter(option: any) {
    switch (option) {
      case 1:
        this.showAllSchools();
        break;
      case 2:
        this.showActiveSchools();
        break;
      case 3:
        this.showInactiveSchools();
        break;
    }
  }

  callPhone(phoneNumber: string){
    if(phoneNumber){
      let a = document.createElement("a");
      a.setAttribute("href", "tel:" + phoneNumber);
      a.click();
    }

  }

}
